<template>
  <div class="navbar">
    <div class="nav_main">
      <div class="logo">
        <img v-if="companyInfo.logo" :src="companyInfo.logo + '?' + new Date().getTime()"
          style="width: 50px; height: 50px; margin-right: 20px;" />
        <div>
          {{ companyInfo.name }}
        </div>
      </div>
      <div class="nav_meau">
        <ul>
          <li :class="{ active: this.$route.path == '/' }">
            <router-link to="/" class="hh">首页</router-link>
          </li>
          <li :class="{ active: this.$route.path == '/case' }">
            <router-link to="/case">产品中心</router-link>
          </li>
          <li :class="{ active: this.$route.path == '/about' }">
            <router-link to="/about">关于我们</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    companyInfo: {
      type: Object
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.navbar {
  position: fixed;
  z-index: 999;
  background-color: #fff;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #007bee;

  .nav_main {
    display: flex;
    margin: 0 auto;
    width: 100%;
    background-color: #fff;
    overflow: hidden;

    .logo {
      height: 58px;
      margin: 15px 0 11px;
      margin-right: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 70%;

      div {
        color: #000;
        font-size: 28px;
        letter-spacing: 2px;
      }
    }

    .nav_meau {
      ul {
        padding-top: 14px;
      }

      li {
        padding: 0 25px;
        position: relative;
        text-align: center;
        cursor: pointer;

        a {
          display: inline-block;
          line-height: 53px;
          color: #454545;
          font-size: 18px;
          letter-spacing: 1px;
        }

        .icon {
          position: absolute;
          top: 15px;
          right: 2px;
        }
      }

      li:last-child {
        padding: 0px 11px !important;
      }

      .active {
        border-bottom: 2px solid #0260bb;
        color: #2c85dc;
      }

      .active a {
        color: #2c85dc;
      }

      li:hover a {
        color: #2c85dc;
      }

      li:last-child {
        padding-right: 0;
      }
    }
  }
}

.router-link-active {
  width: 100%;
  height: 100%;
  display: inline-block !important;
  color: aquamarine;
}
</style>
